module.exports = __webpack_public_path__ + "static/a3-4b82486f306279232c76e11b8ca5dd39.jpg";